var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bg-pill",class:_vm.classes,attrs:{"data-tooltip":_vm.hint}},[_c('fa-icon',{attrs:{"icon":['fal', _vm.icon]}}),_vm._v(_vm._s(_vm.name)+" "),(_vm.round)?_c('span',{staticClass:"bg-status-round"},[_vm._v("· "+_vm._s(_vm.roundName))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }